import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { AccountAPI } from "../../../axios/api";
import {
  useAbortedEffect,
  useSearch,
  useTable,
} from "../../../components/hooks";

import ModuleBreadCrumb from "../../../components/breadCrumb";
import {
  formatOptions,
  setPageSetting,
  formatNumber,
} from "../../../service/common";
import { system_dropdown, system_table } from "../../../service/system";
import { option_account_type } from "../../../service/option";

import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";

export default function BackAccountList() {
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  const crumbItem = [
    {
      key: 1,
      label: "帳號管理",
    },
  ];
  const [reload, setReload] = useState({ list: false });
  const {
    setTbData,
    tbTotalRecords,
    setTbTotalRecords,
    setTbFirstIndex,
    setTbRows,
    setTbColumns,
    renderTable,
    setPageAction,
  } = useTable();
  // 篩選條件
  const defaultFilter = {
      page: 1,
      size: system_table.size,
      enabled: null,
    },
    pagePath = "/account";
  const {
    filterData,
    setFilterData,
    search,
    setSearch,
    changeFilter,
    renderSearchWrap,
  } = useSearch({
    defaultFilter,
    pagePath: [pagePath],
    tbSetting: { setTbFirstIndex, setTbRows },
    reloadAction: () => setReload((state) => ({ ...state, list: true })),
  });
  const [optionData, setOptionData] = useState(null);

  useEffect(() => {
    const action = ({ startIndex, rows }) => {
      let temp = {
        ...search,
        page: Math.floor(startIndex / rows) + 1,
        size: rows,
      };
      setFilterData(temp);
      setSearch(temp);
    };
    setPageAction(
      () =>
        ({ startIndex, rows }) =>
          action({ startIndex, rows })
    );
  }, [search]);

  useEffect(() => {
    let temp = formatOptions({
      account_type: option_account_type,
    });

    setOptionData((state) => ({
      ...state,
      ...temp,
    }));
  }, []);

  // 取得列表資料
  useAbortedEffect(
    (signal) => {
      if (!reload.list || !optionData) return;

      dispatch(setProgress(true));

      setPageSetting({ params: search, page: pagePath });

      let params = {
        ...search,
      };

      AccountAPI.getUserList({ data: params, options: { signal } }).then(
        (result) => {
          let { Response, data, total, message } = result;

          if (Response === 1) {
            data = data.map((item) => ({
              ...item,
              account_type_format:
                optionData.account_type_obj[item.type]?.label,
            }));
            setTbData(data);
            setTbTotalRecords(total);
            setReload((state) => ({
              ...state,
              list: false,
            }));
          } else {
            dispatch(
              setToast({
                severity: "error",
                summary: message,
                detail: "",
              })
            );
          }

          dispatch(setProgress(false));
        }
      );
    },
    [reload, optionData]
  );

  useEffect(() => {
    if (!optionData) return;

    const renderType = (data) => <div>{data.account_type_format}</div>;

    const renderBtnAction = (data) => (
      <Button
        className="p-button-sm"
        type="button"
        label="編輯"
        onClick={() => route_navigate(`/back${pagePath}/${data.id}`)}
      />
    );

    setTbColumns([
      {
        field: "username",
        header: "帳號",
        className: "flex-grow-1",
        style: { flexBasis: "120px" },
      },
      {
        field: "name",
        header: "姓名",
        className: "flex-grow-1",
        style: { flexBasis: "100px" },
      },
      {
        field: "account_type_format",
        header: "帳號類型",
        className: "flex-grow-1",
        style: { flexBasis: "60px" },
        body: (data) => renderType(data),
      },
      {
        field: "id",
        header: "進階",
        className: "w-5rem froze-right",
        alignFrozen: "right",
        frozen: true,
        body: (data) => renderBtnAction(data),
      },
    ]);
  }, [pagePath, optionData]);

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <h2 className="my-3 ml-1">帳號管理</h2>

      <div className="border-round-lg bg-white p-3">
        {/* {renderSearchWrap({
          isShow: true,
          template: (
            <>
              <div className="col-12 md:col-4 xl:col-3 flex align-items-start flex-column mt-2 md:mt-0">
                <label
                  htmlFor="username"
                  className="w-4rem white-space-nowrap text-left mb-1"
                >
                  啟用狀態
                </label>
                <Dropdown
                  name="enabled"
                  className="w-full"
                  value={filterData.enabled}
                  onChange={(e) => changeFilter(e)}
                  options={optionData?.enabled ?? []}
                  optionLabel="label"
                  optionValue="value"
                  emptyFilterMessage={system_dropdown.emptyFilter}
                  showClear
                />
              </div>
              <div
                className={classNames(
                  "col-12 md:col-8 xl:col-9 flex align-items-end mt-2 md:mt-0"
                )}
              >
                <Button
                  className="p-button-info w-auto ml-auto md:ml-0 md:mt-0 px-3"
                  type="button"
                  icon="pi pi-search"
                  label="查詢"
                  onClick={() => {
                    setSearch({
                      ...filterData,
                      page: 1,
                    });
                    setTbFirstIndex(0);
                  }}
                />

                <Button
                  className="w-auto md:ml-auto ml-3 px-3"
                  type="button"
                  label="新增"
                  onClick={() => route_navigate(`/back${pagePath}/add`)}
                />
              </div>
            </>
          ),
        })} */}

        {renderTable({
          className: "mt-2",
          options: { scrollable: true, scrollDirection: "both" },
        })}
      </div>
    </>
  );
}
